<div *ngIf="municipyText">
    <app-image-section-head [title]="title" [description]="description" [image]="image"></app-image-section-head>
    
    <div class="container">
        <div class="row">
            <main id="main-content" class="col-12" [innerHTML]="municipyText"></main>
        </div>
    </div>
</div>